<app-list #list entityName="{{data.entityName}}" module="{{data.module}}" [selectable]="data.select === undefined || data.select"
          [customQuery]="data.customFilters"
          [defaultQuery]="data.defaultFilters"
          [customData]="data.customData"
          [group]="data.displayGroup"
          [dataEntity]="data"
          (selectedEntity)="suggestionWasClicked($event)">
</app-list>
